import { Component, OnInit } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ngos } from './NGOs';
import { Router } from '@angular/router';
@Component({
  selector: 'app-donate',
  templateUrl: './donate.page.html',
  styleUrls: ['./donate.page.scss'],
})
export class DonatePage implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  async visit(name: string) {
    const i = ngos.findIndex((x) => x.name === name);
    const url = ngos[i].visitLink;
    if (url == 'aboutus') {
      this.router.navigateByUrl('aboutus');
    } else {
      await Browser.open({ url });
    }
  }

  async donate(name: string) {
    const i = ngos.findIndex((x) => x.name === name);
    const url = ngos[i].donateLink;
    await Browser.open({ url });
  }
}
